import React, { useEffect, useState } from "react";
import queryString from "query-string";

import db from "../../../services/query";
import PrintHeader from "../common/PrintHeader";
import Img from "../../common/Img";
import lbl from "../../../data/Labels.json";
import {
  formatDateFa,
  getDailySalaryReportLabels,
} from "../../teacher-profile/dailySalaryReportLabels";

function formatMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return `${n.toLocaleString("en-US", {
    minimumFractionDigits: n % 1 ? 2 : 0,
    maximumFractionDigits: 2,
  })} $`;
}

const TeacherDailySalaryPrint = (props) => {
  const { teacher_id } = props.match.params;
  const q = queryString.parse(props.location.search);
  const [body, setBody] = useState(null);

  useEffect(() => {
    const params = [];
    if (q.entry_year_id) params.push(`entry_year_id=${q.entry_year_id}`);
    else if (q.all === "1") params.push("all=1");
    if (q.from) params.push(`from=${q.from}`);
    if (q.to) params.push(`to=${q.to}`);
    const qs = params.length ? `?${params.join("&")}` : "";
    db.getAll(`teachers/${teacher_id}/salary/daily${qs}`).then(({ data }) => {
      setBody(data);
      setTimeout(() => window.print(), 600);
    });
  }, [teacher_id, q.entry_year_id, q.all, q.from, q.to]);

  const summary = body?.summary || {};
  const days = body?.data || [];
  const totals = summary.totals || {};
  const teacher = summary.teacher || {};
  const benefit = Number(totals.total_benefit || 0);
  const periodEarn = Number(totals.day_earn_gross || 0);
  const todayEarn = Number(
    totals.today_earn_gross != null ? totals.today_earn_gross : periodEarn
  );
  const grandTotal = Number(
    totals.with_benefits != null
      ? totals.with_benefits
      : periodEarn + benefit
  );
  const teacherName = teacher.teacher_name || q.teacherName || "";
  const yearLabel =
    (q.entry_year_id
      ? (summary.entry_years || []).find(
          (ey) => String(ey.entry_year_id) === String(q.entry_year_id)
        )?.entry_year
      : null) ||
    (q.all === "1" ? "تمام سمسترها" : null) ||
    "تمام سمسترها";

  const reportLabels = getDailySalaryReportLabels({
    yearLabel,
    from: q.from,
    to: q.to,
  });

  const printHeadTexts = ["معاونیت امور اداری و مالی", "مدیریت مالی"];

  const stats = [
    { label: lbl.Present || "حاضر", value: totals.present_count || 0 },
    { label: lbl.Substitute || "بدل", value: totals.substitute_count || 0 },
    { label: lbl.Absent || "غایب", value: totals.absent_count || 0 },
    {
      label: "کردت قابل پرداخت",
      value: totals.paid_session_count || 0,
    },
    { label: lbl.Benefits || "امتیازات", value: formatMoney(benefit) },
    {
      label: lbl.DailyEarnings || "معاش امروز",
      value: formatMoney(todayEarn),
      accent: true,
    },
  ];

  return (
    <main className="main-print-wrapper teacher-daily-salary-print">
      <PrintHeader
        title="گزارشات"
        subtitle={reportLabels.headerSubtitle}
        date=" "
        printHeadTexts={printHeadTexts}
      />

      <section className="tds-hero">
        <div className="tds-hero-profile">
          <div className="tds-hero-photo">
            <Img src={teacher.teacher_photo} />
          </div>
          <div className="tds-hero-meta">
            <h3>{teacherName}</h3>
            <p>{teacher.faculty || ""}</p>
            {teacher.teacher_phone ? <p>{teacher.teacher_phone}</p> : null}
            {teacher.aria_id ? <p>{teacher.aria_id}</p> : null}
          </div>
          <div className="tds-hero-earn">
            <em>مجموع</em>
            <b>{formatMoney(grandTotal)}</b>
          </div>
        </div>

        <div className="tds-hero-summary">
          <div className="tds-hero-summary-title">{lbl.Summary || "خلاصه"}</div>
          <div className="tds-hero-stats">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className={`tds-hero-stat${stat.accent ? " is-accent" : ""}`}
              >
                <b>{stat.value}</b>
                <span>{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <p style={{ color: "var(--blue)", textAlign: "center" }}>
        {reportLabels.tableTitle}
      </p>

      <div className="print-table-area">
        <table>
          <colgroup>
            <col style={{ width: "11%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "18%" }} />
            <col style={{ width: "6%" }} />
            <col style={{ width: "7%" }} />
            <col style={{ width: "6%" }} />
            <col style={{ width: "8%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "14%" }} />
          </colgroup>
          <thead>
            <tr>
              <th>تاریخ</th>
              <th>سمستر</th>
              <th>مضامین همان روز</th>
              <th>حاضر</th>
              <th>جایگزین</th>
              <th>غایب</th>
              <th>کردت قابل پرداخت</th>
              <th>معاش فی ساعت</th>
              <th>معاش روز</th>
              <th>قابل پرداخت</th>
            </tr>
          </thead>
          <tbody>
            {days.map((row, i) => (
              <tr key={`${row.attendance_date}-${row.entry_year_id}-${i}`}>
                <td>
                  {formatDateFa(row.attendance_date)}
                  <br />
                  <small dir="ltr">
                    {String(row.attendance_date || "").slice(0, 10)}
                  </small>
                </td>
                <td>{row.entry_year}</td>
                <td className="daily-salary-print-subjects">
                  {String(row.subjects || "")
                    .split(" | ")
                    .filter(Boolean)
                    .join(" · ")}
                </td>
                <td>{row.present_count}</td>
                <td>{row.substitute_count}</td>
                <td>{row.absent_count}</td>
                <td>{row.paid_session_count}</td>
                <td>{formatMoney(row.salary_per_hour)}</td>
                <td>{formatMoney(row.day_earn_gross)}</td>
                <td>{formatMoney(row.day_earn_gross)}</td>
              </tr>
            ))}
          </tbody>
          {/* table-row-group → totals print once at end, not on every page */}
          <tfoot>
            {benefit > 0 ? (
              <tr className="daily-salary-benefit-row">
                <td colSpan={3}>امتیازات</td>
                <td />
                <td />
                <td />
                <td />
                <td />
                <td />
                <td>{formatMoney(benefit)}</td>
              </tr>
            ) : null}
            <tr className="daily-salary-total-row">
              <td colSpan={3}>مجموعه</td>
              <td>{totals.present_count || 0}</td>
              <td>{totals.substitute_count || 0}</td>
              <td>{totals.absent_count || 0}</td>
              <td>{totals.paid_session_count || 0}</td>
              <td />
              <td>{formatMoney(periodEarn)}</td>
              <td>{formatMoney(grandTotal)}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "auto auto auto",
          paddingTop: "50px",
        }}
      >
        <div className="print-identity">
          <div className="print-signature-area">
            <div className="wrapper" style={{ width: "80%" }}>
              <hr />
              <p>نام و امضاء تایید کننده</p>
            </div>
          </div>
        </div>
        <div className="print-identity">
          <div className="print-signature-area">
            <div className="wrapper" style={{ width: "80%" }}>
              <hr />
              <p>نام و امضاء پرداخت کننده</p>
            </div>
          </div>
        </div>
        <div className="print-identity">
          <div className="print-signature-area">
            <div className="wrapper" style={{ width: "80%" }}>
              <hr />
              <p>نام و امضاء گیرنده</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TeacherDailySalaryPrint;
